import React from 'react';

import BLOCK_RIZ_CONFIG from 'shared-constants/src/blockRizConfig';
import trackGTMEvents from '../trackGTMEvents/new';
import blockRizLogic from '../blockRizLogic';
import { setItem, getItem } from '../localStorage';

import openFeedbackModal from './openFeedbackModal';

const successFeedback = (
  <>
    <p className="rizmdl__txt tp-s--l tp-w--m c-txt--f0 tp-a--c mb--m">
      Grazie!
    </p>
    <p className="rizmdl__txt tp-s--m tp-w--s c-txt--secondary tp-a--c">
      La richiesta è stata inviata con successo
    </p>
  </>
);

const failFeedback = (
  <p className="rizmdl__txt--err tp-s--l tp-w--m c-txt--f0 tp-a--c mb--m">
    Oops... qualcosa è andato storto!
    <br />
    Invia di nuovo la richiesta.
  </p>
);

export default ({
  openModalAction,
  createGenericAfterSpecificModal,
  createFeedbackModal,
  closeModalAction,
  title,
  listingId,
  channel,
  category,
  propertyTypeGroup,
  publisherName,
  device,
  rizLocation,
  userData,
  filters,
  locations,
  app,
  isMobile,
  isFromSaveSearch,
  disableHistoryBackOnClose,
}) => {
  const sendGenericLeadCallback = async ({
    response,
    closeModal,
  }) => {
    const success = response.data && response.data.code === 201;

    if (success) {
      if (!isFromSaveSearch) {
        trackGTMEvents({
          category: 'Lead',
          action: 'SendGeneric',
          label: listingId.toString(),
        }, { position: 'ContactForm' });
      } else {
        trackGTMEvents({
          category: 'Lead',
          action: 'SendGeneric',
        });
      }

      /* TECH-5965 */
      const rizStorageArray = getItem('csa_riz_to_block') || [];
      const rizData = {
        email: userData.email,
        channel: channel || '',
        category: category || '',
        propertyTypeGroup: propertyTypeGroup || '',
        locationCode: rizLocation,
      };
      const { newRizStorageArray } = blockRizLogic(
        rizStorageArray,
        rizData,
        BLOCK_RIZ_CONFIG,
      );
      setItem('csa_riz_to_block', newRizStorageArray);
      /* TECH-5965 */
    }

    await closeModalAction({ close: closeModal });

    setTimeout(() => {
      openFeedbackModal({
        openModalAction,
        createFeedbackModal,
        isMobile,
        fail: !success,
        failMethod: null,
        feedback: success
          ? successFeedback
          : failFeedback,
        title,
        disableHistoryBackOnClose,
      });
    }, 301);
  };

  openModalAction(createGenericAfterSpecificModal({
    title,
    listingId,
    filters,
    publisherName,
    device,
    userData,
    locations,
    app,
    sendGenericLeadCallback,
    isFromSaveSearch,
    disableHistoryBackOnClose,
  }));
};
